<div class="card-group">
  <ng-container *ngIf="crimeGunFirearm; else loadingfirearm">
    <div class="card text-bg-success border-end border-light">
      <div class="card-body justify-content-center align-items-center vertical-align-card">
        <div>
          <h1 class="card-title">Crime Gun ID:<br />{{ crimeGunFirearm.CrimeGunNumber }}</h1>
          <div class="card-text">Gun recovered: {{ crimeGunFirearm.IsCrimeGunRecovered | booleanTransform }}</div>
          <div class="card-text">{{ mostRecentTriageDataForUser }}</div>
        </div>
      </div>
    </div>
    <div class="card text-bg-success border-end border-light">
      <div class="card-body">
        <h2 class="card-title">Firearm Data</h2>
        <ul class="list-unstyled">
          <li>Firearm type: {{ crimeGunFirearm.FirearmType}}</li>
          <li>Manufacturer: {{ crimeGunFirearm.Manufacturer}}</li>
          <li>Model: {{ crimeGunFirearm.ModelDescription}}</li>
          <li>Caliber: {{ crimeGunFirearm.Caliber}}</li>
          <li>Serial number: {{ crimeGunFirearm.SerialNumber}}</li>
        </ul>
      </div>
    </div>
    <div class="card text-bg-success border-end border-light">
      <div class="card-body">
        <h2 class="card-title">Most Recent Trace Data</h2>
        <ul class="list-unstyled">
          <li>FTS ID: {{ crimeGunFirearm.FTSIDs }}</li>
          <ng-container *removeIfNoPermission="canViewFTS">
            <li>Purchase date: {{ crimeGunFirearm.PurchaseDate | date:'MM/dd/yyyy' }}</li>
          </ng-container>
          <ng-container>
            <li class="mt-3" pTooltip="{{ttfsTooltip}}" placeholder="right">Time to 1st Shooting: {{ crimeGunFirearm.TimeToFirstShooting != null ? crimeGunFirearm.TimeToFirstShooting + ' days' : ''}}</li>
          </ng-container>
          <ng-template #notooltip>
            <li class="mt-3">Time to 1st Shooting: {{ crimeGunFirearm.TimeToFirstShooting != null ? crimeGunFirearm.TimeToFirstShooting + ' days' : ''}}</li>
          </ng-template>
        </ul>
      </div>
    </div>
    <div class="card text-bg-success border-light">
      <div class="card-body">
        <h2 class="card-title">Additional Data</h2>
        <ul class="list-unstyled">
          <li>Stolen gun: {{ crimeGunFirearm.IsStolenGun | booleanTransform }}</li>
          <li>Obliterated serial number: {{ crimeGunFirearm.ObliteratedSerialNumber | booleanTransform }}</li>
          <li>Amended serial number: {{ crimeGunFirearm.AmendedSerialNumber}}</li>
          <li>
            <ness-inline-edit-text [canEdit]="canEditCrimeGun" [textInputModel]="textInputModel$ | async" (onSave)="onLegacyATFGunNumberSave($event)"></ness-inline-edit-text>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
  <ng-template #loadingfirearm>
    <div class="card text-bg-success">
      <div class="card-body">
        <p class="p-3">
          <i class="fa fas fa-spinner fa-spin me-2" aria-hidden="true"></i> Loading Firearm Data...
        </p>
      </div>
    </div>
  </ng-template>
</div>
